import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute1 = ({
  width = 479,
  height = 617,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 1344,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 479 617"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M24,302.5C51,311 90.5,292 81.5,189.5C72.5,87 19.5003,76 4.00032,32C-8.39968,-3.19999 14.8337,-0.999992 28.0003,4.50001C140.5,52 145,154 175.5,197.5C206,241 234,149 244.5,125.5C255,102 258,123.5 257,176.5C256,229.5 283.616,245.987 335,266C382.5,284.5 395.211,406.389 419,473C431,506.6 465.334,582.333 481,616"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M24,302.5C51,311 90.5,292 81.5,189.5C72.5,87 19.5003,76 4.00032,32C-8.39968,-3.19999 14.8337,-0.999992 28.0003,4.50001C140.5,52 145,154 175.5,197.5C206,241 234,149 244.5,125.5C255,102 258,123.5 257,176.5C256,229.5 283.616,245.987 335,266C382.5,284.5 395.211,406.389 419,473C431,506.6 465.334,582.333 481,616"
      />

      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M17.0572 298.811C16.9432 298.611 17.0893 298.362 17.3203 298.363L23.6709 298.409C23.9019 298.411 24.0444 298.662 23.9275 298.861L20.7123 304.338C20.5954 304.537 20.3067 304.535 20.1927 304.334L17.0572 298.811Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute1
